import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router'
import store from './store'
import VueCookies from 'vue-cookies'
import interceptors from './plugins/interceptors'
import moment from 'moment'

interceptors();
Vue.prototype.moment = moment
Vue.config.productionTip = false
Vue.use(VueCookies)

// set default config
Vue.$cookies.config('14d')

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')